import { Nes }                                         from '@/Emulator';
import { IComponent }                                  from '@/Interface/IComponent';
import { Component, h, Host, JSX, Prop, State, Watch } from '@stencil/core';

@Component({
    tag:      'nes-viewport',
    styleUrl: './nes-viewport.scss',
    shadow:   true,
})
export class NesViewport implements IComponent
{
    @Prop() public nes!: Nes;

    @State() private fps: number = 0;
    @State() private canvas: Maybe<HTMLCanvasElement>;

    public componentDidLoad(): void
    {
        this.nes.on('fps-update', fps => this.fps = fps);
    }

    public render(): JSX.Element
    {
        return (
            <Host>
                <main>
                    <canvas
                        width="256"
                        height="240"
                        ref={el => this.canvas = el!}
                    />
                    <section>
                        <code>{this.fps}</code>
                        <slot/>
                    </section>
                </main>
            </Host>
        );
    }

    @Watch('canvas')
    private onCanvasChanged(): void
    {
        this.nes.setOutputCanvas(this.canvas ?? null);
    }
}
